import { useState, useEffect, useRef } from "react"
import { Row, Col } from "react-bootstrap"
import PredictAndFeedback from "components/PricePredictor/PredictAndFeedback"
import Displays from "components/PricePredictor/Displays"

const PricePredictor = () => {
  const [width, setWidth] = useState(200)
  const rowRef = useRef(null)
  useEffect(() => {
    if (rowRef.current) {
      const width = rowRef.current.offsetWidth
      setWidth(width)
    }
  }, [])
  return (
    <>
      <Row>
        <PredictAndFeedback />
      </Row>
      <Row ref={rowRef} className='mt-5'>
        <Displays width={width} />
      </Row>
    </>
  )
}

export default PricePredictor
